import React from 'react'

import { closeModal, ModalCard } from 'Components/Modal'
import { H3 } from 'Components/shared/Typography'
import { Button } from 'Components/shared/Button'
import { Row } from 'Components/shared/Container'
import { colors } from 'Constants'
import CustomLinkService from 'Services/customlinks'
import { toastWithErrorMessage } from 'Helpers/toast'

const DeleteLinkModal = ({ customLink, updateLinks, customLinks, onCancel = closeModal }) => {
  return (
    <ModalCard>
      <Row>
        <H3>Are you sure you want to delete custom link with name {customLink.shortName}?</H3>
      </Row>
      <Row>
        <Button onClick={onCancel} color={colors.red} style={{ marginRight: '4px' }}>
          Cancel
        </Button>
        <Button
          onClick={e => {
            e.preventDefault()

            CustomLinkService.deactivate({
              id: customLink.id,
              data: { deleted: 1, clubimpact_id: customLink.clubId }
            })
              .then(() => {
                const newIds = customLinks.map(link => link.id)
                const idx = customLinks.indexOf(customLink)
                if (idx === -1) {
                  // Couldn't find the link
                  toastWithErrorMessage('Failed to remove the custom link.')
                  onCancel()
                } else {
                  newIds.splice(idx, 1)
                  updateLinks({ ids: newIds })
                  onCancel()
                }
              })
              .catch(() => {
                toastWithErrorMessage('Failed to remove custom link.')
                onCancel()
              })
          }}
          style={{ marginLeft: '4px' }}
        >
          Delete
        </Button>
      </Row>
    </ModalCard>
  )
}

const DeleteNewLinkModal = ({
  customLink,
  customLinks,
  setCustomLinks,
  updateLinks,
  onCancel = closeModal
}) => {
  return (
    <ModalCard>
      <Row>
        <H3>Are you sure you want to delete custom link with name {customLink.shortName}?</H3>
      </Row>
      <Row>
        <Button onClick={onCancel} color={colors.red} style={{ marginRight: '4px' }}>
          Cancel
        </Button>
        <Button
          onClick={e => {
            e.preventDefault()
            customLinks.splice(customLinks.indexOf(customLink), 1)
            setCustomLinks({ ...customLinks })
            updateLinks()
            onCancel()
          }}
          style={{ marginLeft: '4px' }}
        >
          Delete
        </Button>
      </Row>
    </ModalCard>
  )
}

export { DeleteLinkModal, DeleteNewLinkModal }
